import i18n from '@/langs/i18n.js';

export default [
  {
    text: i18n.t('promotions.status.free'),
    value: 'FREE',
    badgeTheme: 'sent'
  },
  {
    text: i18n.t('promotions.status.auction'),
    value: 'AUCTION',
    badgeTheme: 'waiting-for-offer'
  },
  {
    text: i18n.t('promotions.status.occupied'),
    value: 'OCCUPIED',
    badgeTheme: 'cancelled'
  }
]
